export default "__VITE_ASSET__F83Yqjuh__"